import { Box } from '@mui/material';
import { style } from './style';
import { FieldProps } from '../Field';

interface FieldLabelProps {
  label: FieldProps['label'];
  id?: string;
}

function FieldLabel(props: FieldLabelProps) {
  const { label, id } = props;

  return (
    <Box sx={style.label} component='label' htmlFor={id}>
      {label}
    </Box>
  );
}

export default FieldLabel;
